import { EditOutlined, LoadingOutlined } from '@ant-design/icons';
import { Card, Col, ConfigProvider, Input, Pagination, Row, Spin, Table, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next'
import { WorkScheduleReportModel } from 'models/workSchedule';
import React, { useEffect, useRef, useState } from 'react'
import i18next from 'i18next';
import { UserData } from 'utils/helpers/encrypt-decrypt-user';
import { UserModel } from 'models/users';
import UseGetEmployeeWorkReports from 'hooks/query/workSchedule/UseGetEmployeeWorkReports';
import SkeletonTable, { SkeletonTableColumnsType } from 'components/SkeletonsLoading/SkeletonTable';
import { ColumnsType } from 'antd/es/table';
import { useWidth } from 'utils/helpers/use-is-mobile';

const options: {day: string; value: number}[] = [
    {
        day: 'monday',
        value: 1
    },
    {
        day: 'tuesday',
        value: 2
    },
    {
        day: 'wednesday',
        value: 3
    },
    {
        day: 'thursday',
        value: 4
    },
    {
        day: 'friday',
        value: 5
    },
    {
        day: 'saturday',
        value: 6
    },
    {
        day: 'sunday',
        value: 7
    },
];

const EmployeeWorkReports = () => {
  const { t } = useTranslation()
  const [page, setPage] = useState<number>(1);
  const [perPage] = useState<number>(8);

  const { data, isLoading, isFetching } = UseGetEmployeeWorkReports(
    page,
    perPage
  )
const mapDays = (days: number[]) => 
  days?.map(element1 => {
    const option = options.find(element2 => element2.value === element1)
    return option ? t(option.day ): ''
  }).join(", ");
  const { isMobile } = useWidth();

  const columns: ColumnsType<WorkScheduleReportModel> = [
    {
      title: t("technical_name"),
      dataIndex: "full_name",
      key: "full_name",
    },
    {
      title: t("planned_hours"),
      dataIndex: "planned_hours",
      key: "planned_hours",
    },
    {
      title: t("worked_hours"),
      dataIndex: "worked_hours",
      key: "worked_hours",
    },
    {
      title: t("overtime_hours"),
      dataIndex: "overtime_hours",
      key: "overtime_hours",
    },
    {
      title: t("vacations_count"),
      dataIndex: "vacations_count",
      key: "vacations_count",
    },
    {
      title: t("work_days"),
      key: "day_of_week",
      render: (_, record) => {
        const days = record.work_schedules?.day_of_week;

        if (!days || days.length === 0) return "-";

        return mapDays(days);
      },
    },
    {
      title: t("start_time"),
      key: "start_time",
      render: (_, record) =>
        record.work_schedules?.start_time ?? "-",
    },
    {
      title: t("end_time"),
      key: "end_time",
      render: (_, record) =>
        record.work_schedules?.end_time ?? "-",
    },
  ];

  const deviceColumns: ColumnsType<WorkScheduleReportModel> = [
    {
      render: (obj: WorkScheduleReportModel) => {
        return (
          <div
            style={{
              boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
              padding: "0",
              borderRadius: "18px",
              overflow: "hidden",
            }}
          >
            <div className="lable">
              <>
                <div
                  style={{
                    textAlign: "center",
                    marginBottom: "1rem",
                    backgroundColor: "#ccc",
                    padding: "0.3rem 0",
                  }}
                >
                  <span>{t("technical_name")}:</span>
                  <span
                    style={{
                      width: "fit-content",
                      padding: "7px",
                      borderRadius: "50%",
                    }}
                  >
                    {" "}
                    {obj.full_name}
                  </span>
                </div>
              </>
            </div>
            <Row style={{ padding: "20px", paddingTop: "0" }}>
              <Col md={12} span={24}>
                <div className="label" style={{ marginBottom: "4px" }}>
                  <span>{t("tickets_count")}: </span>
                  {obj.overtime_hours}
                </div>
              </Col>
            </Row>
          </div>
        );
      },
    },
  ];

  return (
    <div style={{ padding: "10px" }}>
      <div>
      <SkeletonTable
        loading={isLoading || isFetching}
        columns={columns as SkeletonTableColumnsType[]}
      >
        <Table
          dataSource={data?.data}
          columns={isMobile ? deviceColumns : columns}
          pagination={false}
          loading={isLoading}
        />
      </SkeletonTable>
      <Pagination
        showSizeChanger={false}
        pageSize={8}
        onChange={(e) => setPage(e)}
        current={page}
        total={data?.meta?.total}
      />
      </div>
    </div>
  )
}

export default EmployeeWorkReports